import {useState, useEffect, useContext} from 'react'
import {UpdateUserContext} from "../../App"
import {MathJax, MathJaxContext } from "better-react-mathjax";
//import {Tab_questions} from "./tab_questions"
import {Aff_question} from "./Aff_question"
import {Chargement} from "./Chargement"
import {multi_search, affiche_param} from "../Fonctions"

export function Choisir({auth, selection, niveau, msg, setMsg, cleanMsg, cleanDevoir_cree, setDevoir_cree, devoir_cree}) {
  const [save_serie, setSave_serie] = useState(false)
  const [save_serie_and_send, setSave_serie_and_send] = useState(true)

  const updateUsercontext = useContext(UpdateUserContext)
  
  const [questionsId, setQuestionsId] = useState({})
  const [questionsIdSave, setQuestionsIdSave] = useState({})
  const [myQuestionsOnly, setMyQuestionsOnly] = useState(false)
  const [mesquestionsId, setMesQuestionsId] = useState({})
  const [listeChoix, setlisteChoix] = useState('')
  const [suppr_created, setSuppr_created] = useState(false)

  // Dates
  const dat = new Date()
  const dat_month = dat.getMonth()+1 < 10 ? '0'+ (dat.getMonth()+1) : dat.getMonth()+1
  const dat_day = dat.getDate() < 10 ? '0'+ (dat.getDate()) : dat.getDate()
  const today = dat.getFullYear() + '-' + dat_month + '-' + dat_day
  const cleanDate = (date) => date.slice(-2)+'/'+date.slice(-5,-3)

  //const [questions0, setQuestions0] = useState([])
  //const [mesquestions, setMesquestions] = useState([])
  /*const [questions, setQuestions] = useState([])*/
  const [chargement, setChargement] = useState(true)

  useEffect((questions0)=>{
    fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
      method: 'POST',
      body: JSON.stringify({...auth, action:'rech_question_choisi', niveau:niveau})
    })
    .then(response => response.json())
    .then(data => {
      //console.log(data)
      const quest_created = data[0]
      const quest_all = data[1]
      const tab = {}
      let etoile = ''
      if(auth.etoile.includes('⭐')){etoile = auth.etoile.split('⭐').length-1}
        etoile=''  // MODIFIER : supprimer le fait de filtrer par étoile
      Object.keys(selection).forEach(sel => {
        quest_created.forEach((quest,k) => {
          if(selection[sel].length > 0){selection[sel].map(e => quest[0].toLowerCase().includes(sel.toLowerCase()) && quest[1].toLowerCase().includes(e.toLowerCase()) && quest[1].split('*').length-1 === etoile ? 
              tab['created'+quest[4]]=quest :
              (quest[0].toLowerCase().includes(sel.toLowerCase()) && quest[1].toLowerCase().includes(e.toLowerCase()) && !etoile ? tab['created'+quest[4]]=quest : false ))}
          else if(quest[0].toLowerCase().includes(sel.toLowerCase()) && quest[1].split('*').length-1 === etoile){tab['created'+quest[4]]=quest}
          else if(quest[0].toLowerCase().includes(sel.toLowerCase()) && !etoile){tab['created'+quest[4]]=quest}
        })
        quest_all.forEach((quest,k) => {
          if(selection[sel].length > 0){selection[sel].map(e => quest[0].toLowerCase().includes(sel.toLowerCase()) && quest[1].toLowerCase().includes(e.toLowerCase()) && quest[1].split('*').length-1 === etoile ? 
              tab[k]=quest :
              (quest[0].toLowerCase().includes(sel.toLowerCase()) && quest[1].toLowerCase().includes(e.toLowerCase()) && !etoile ? tab[k]=quest : false ))}
          else if(quest[0].toLowerCase().includes(sel.toLowerCase()) && quest[1].split('*').length-1 === etoile){tab[k]=quest}
          else if(quest[0].toLowerCase().includes(sel.toLowerCase()) && !etoile){tab[k]=quest}
        })
      })
      //console.log(quest_all)
      setQuestionsId(tab)
      setQuestionsIdSave(tab)
      setChargement(false)

      if(suppr_created) {
        setTabAff(tab)
        setMyQuestionsOnly(false)
        setSuppr_created(false)
      }
      
      
      /////// A virer plus tard ////////
      //setQuestions(Object.values(tab))
      //setQuestions0(Object.values(tab))
      //////////////////////////////////
    })
    .catch(err => console.log(err))
  },[suppr_created]);

  let [etoileChoisie, setEtoileChoisie] = useState('')
  let [startNav, setStartNav] = useState(0)
  let [tabAff, setTabAff] = useState(questionsId)

  useEffect(()=>{
    if(Object.keys(questionsId).slice(startNav,startNav + 3).length){
      let [a, b, c] = Object.keys(questionsId).slice(0,3)
      setTabAff({
        [a]:questionsId[a],
        [b]:questionsId[b],
        [c]:questionsId[c]
      })
    }
  },[questionsId]);

  useEffect(()=>{    
    setDevoir_cree({...devoir_cree, listeChoix:Object.keys(mesquestionsId)})
  },[tabAff]);

  useEffect(()=>{    
    if(typeof window?.MathJax !== "undefined"){
      window.MathJax.typeset()
    }
  },[devoir_cree]);

  const handleNav = (e) => {

    if(e.target.className === 'suivant' && startNav + 3 < Object.keys(questionsId).length) {
      const num_question = startNav + 3 
      setStartNav(num_question)
      let [a, b, c] = Object.keys(questionsId).slice(num_question, num_question + 3)
      setTabAff({
        [a]:questionsId[a],
        [b]:questionsId[b],
        [c]:questionsId[c]
      })
    }
    if(e.target.className === 'precedent') {
      const num_question = Math.max(startNav - 3, 0)
      setStartNav(num_question)
      let [a, b, c] = Object.keys(questionsId).slice(num_question, num_question + 3)
      setTabAff({
        [a]:questionsId[a],
        [b]:questionsId[b],
        [c]:questionsId[c]
      })
    }
  }
  const handleChange = (e) => {
    const search = e.target.value
    //const question_copy0 = [...questions0]
    //let question_copy = []

    //question_copy = [...question_copy0.filter(q=>clean(q[0]).includes(clean(e.target.value))
    //question_copy = [...question_copy0.filter(q => multi_search(search, q.join('')))]
    //setQuestions(question_copy)

    if(!Object.keys(questionsIdSave)[0]){setQuestionsIdSave(questionsId)}
    let obj = {}
    Object.keys(questionsIdSave).forEach(key => {
      if(multi_search(search, questionsIdSave[key].join(''))
        || (search.includes('+') ? search.split('+').every(elt => multi_search(elt, questionsIdSave[key].join(''))):false)) {
        obj = {...obj, [key]:questionsIdSave[key]}
      }
    })

    if(Object.keys(obj).length === 0){setTabAff({})}
    setQuestionsId(obj)
    //console.log(obj)
  }

  const handleClickEtoile = (e) => {
    const etoile = e.target.innerText
    setStartNav(0)
    setMyQuestionsOnly(false)
    let obj = {}
    if(!Object.keys(questionsIdSave)[0]){setQuestionsIdSave(questionsId)}

    Object.keys(questionsIdSave).forEach(key => {
      if(etoile === '⭐' && questionsIdSave[key][1].split('*').length === 2){
          obj = {...obj, [key]:questionsIdSave[key]}
      } else if(etoile === '⭐⭐' && questionsIdSave[key][1].split('*').length === 3){
          obj = {...obj, [key]:questionsIdSave[key]}
      } else if(etoile === '⭐⭐⭐' && questionsIdSave[key][1].split('*').length === 4){
          obj = {...obj, [key]:questionsIdSave[key]}
      } else if(etoileChoisie === etoile) {
          obj = {...obj, [key]:questionsIdSave[key]}
      }
    })

    if(etoileChoisie === etoile) {setEtoileChoisie('')}
    else {setEtoileChoisie(etoile)}
    setQuestionsId(obj)
  }

  const handleClick = (e) => {
    /*if (e.target.attributes.name.nodeValue === 'save_serie') {
      setSave_serie(!save_serie)
      return
    }
    if (e.target.attributes.name.nodeValue === 'save_serie_and_send') {
      setSave_serie_and_send(!save_serie_and_send)
      return
    }*/

    if(e.target.attributes.name.nodeValue === 'myQuestionsOnly') {
      const created_ids = Object.keys(questionsId).filter(e => e.includes('created') && !Object.keys(mesquestionsId).includes(e))
      const myQuestionsTab = {}
      created_ids.forEach(e => myQuestionsTab[e]=questionsId[e])

      if(myQuestionsOnly) {
        setQuestionsId(questionsIdSave)
      } else {
        setQuestionsIdSave(questionsId)
        setQuestionsId(myQuestionsTab)
      }
      setStartNav(0)
      setMyQuestionsOnly(!myQuestionsOnly)
    }

    if (e.target.innerText === 'Ajouter') {
      if(Object.keys(mesquestionsId).length >= 10 ) {return}
      setMesQuestionsId({...mesquestionsId, [e.target.name]:questionsId[e.target.name]})
      let copy = questionsId
      delete copy[e.target.name]
      setQuestionsId(copy)
      let [a, b, c] = Object.keys(copy).slice(startNav, startNav + 3)
      setTabAff({
        [a]:questionsId[a],
        [b]:questionsId[b],
        [c]:questionsId[c]
      })

      const copy_choise = listeChoix + '__' + e.target.name + '__'
      setlisteChoix(copy_choise)


    if(questionsId[a] === undefined){
      setQuestionsId(questionsIdSave)
      setStartNav(0)
      setMyQuestionsOnly(false)
      /*const ids = Object.keys(questionsIdSave)
      setTabAff({
        [ids[0]]:questionsIdSave[ids[0]],
        [ids[1]]:questionsIdSave[ids[1]],
        [ids[2]]:questionsIdSave[ids[2]]
      })*/
    }
    }
    if (e.target.innerText === 'Retirer')  {
      setQuestionsId({...questionsId, [e.target.name]:mesquestionsId[e.target.name]})
      delete mesquestionsId[e.target.name]

      const copy_choise = listeChoix.replace('__' + e.target.name + '__', '')
      setlisteChoix(copy_choise)
    }
    if(e.target.className === 'suppr_serie') {
      let confirm = window.confirm("Voulez-vous vraiment supprimer cette question ?");
      if (!confirm) {return}
      auth = {...auth, action:'supp_created_question', num_question:e.target.id}
      sendData(auth, 'supp_created_question')
      setSuppr_created(true)
      setStartNav(0)
      //e.target.parentNode.parentNode.remove()
    }
  }

  const sendData = (auth, name) => {
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify(auth)
    })
    .then(response => response.json())
    .then(data => {
      setMsg({...msg, [name]:data})
      cleanMsg(name)
      setlisteChoix('')
      setMesQuestionsId({})
      updateUsercontext()
      //updateUser()
      if(name !== 'supp_created_question') {
        setTimeout(e => {
          cleanDevoir_cree()
        }, 3000)
      }
    })
    .catch(err => console.log(err))
  }

  const handleSubmit = (e) => {
    const name = e.target.attributes.name.nodeValue
    auth = {...auth, action:name, field:listeChoix.slice(2,-2).replaceAll('____','_'), niveau, nb_question:listeChoix.slice(2,-2).replaceAll('____','_').split('_').length, etoile:auth.etoile || "0", save_serie:save_serie, save_serie_and_send:save_serie_and_send}
    sendData(auth, name)
    //console.log(auth)
  }

  //console.log(mesquestionsId)
  return (
    chargement ? <Chargement/> : 
    <div>
        <MathJaxContext>
        </MathJaxContext>

      <div className="choix_questions">
      Choisir des questions &nbsp;
        <input type="text" onChange={handleChange} placeholder=" Recherche rapide" style={{display: "yes"}} />  
        {affiche_param(['⭐', '⭐⭐', '⭐⭐⭐'], etoileChoisie, 'etoile', handleClickEtoile)}

        {Object.keys(questionsId).filter(e => e.includes('created'))[0] && <span className={'btn_param'+ (myQuestionsOnly ? ' active' : '') } name="myQuestionsOnly" title="Afficher seulement mes questions" onClick={handleClick}>Mes questions</span>}
        <br/>
        {Object.keys(tabAff)?.map((id, k)=> 
         <Aff_question key={k} key_tab={id} question={tabAff[id]} handleClick={handleClick} tag={"Ajouter"} />
        )}
        {msg.supp_created_question ? <span dangerouslySetInnerHTML={{ __html:msg.supp_created_question}}></span> : ''}
        <span>
         {startNav ? <div className="precedent" onClick={handleNav}></div> : ''} 
         {startNav+3 < Object.keys(questionsId).length ? <div className="suivant" onClick={handleNav}></div> :''}
       </span>
      </div>
      <hr/>

      {(Object.keys(mesquestionsId).length > 0 || msg.listeChoix ) && 
      <div className="etiquettes">
        &emsp; &emsp; Liste des questions choisies : <br/>
        {msg.listeChoix ? <span dangerouslySetInnerHTML={{ __html:msg.listeChoix}}></span> : ''}
        {Object.keys(mesquestionsId).map((id0, k0) => 
         <Aff_question key={k0} key_tab={id0} question={mesquestionsId[id0]} handleClick={handleClick} tag={"Retirer"} />
        )}
        <br/>
      </div>
      }

      {  /*   =======================  
                  Cadre Selection  
              =======================
          */
        (/*devoir_cree.mode_aleatoire &&*/ Object.keys(devoir_cree.selection).length !==0) && 
        <div id="selection" className="cadre_selection" align="center">
          <div align="left" className="message resultat" style={{backgroundColor:auth.color_devoir[devoir_cree.classe]}} >
            <div className="info_mess">{cleanDate(today)}<br/>
            {devoir_cree.date_limit === 'Oui' ? <span className="date_limit_arrow">{cleanDate(devoir_cree.date_limit_value)}</span> : ''}</div> 
            {devoir_cree.optionnel === 'Oui' ? <div className="facultatif_mark" title="Devoir optionnel"></div> : ''}
            <div className="note_serie">{devoir_cree.classe}</div> <div className="nb_question">{Object.keys(mesquestionsId).length}Q</div>
            &nbsp;
            {devoir_cree.nbEssaisMin > 1 && '(' + devoir_cree.nbEssaisMin + ' essais minimum)'}
            <br/>
            {devoir_cree.titre && <>{devoir_cree.titre} <br/></>}
            {devoir_cree.comm_active && <div style={{color:'teal', fontSize:'0.8em'}} ><em>{devoir_cree.comm_active}</em> <br/></div>}

            <hr style={{color:'lightgrey'}} />

            {Object.keys(mesquestionsId).length > 0 && 
                <div align="center">
                  Sauvegarder ma série ? &nbsp;
                  <span name = "save_serie" className={'btn_param'+(save_serie ? ' active' :'')} onClick={()=>setSave_serie(true)}>Oui</span> &nbsp;
                  <span name = "save_serie" className={'btn_param'+(!save_serie ? ' active' :'')} onClick={()=>setSave_serie(false)}>Non</span><br/>

                  Envoyer au groupe {auth.classe} &nbsp;
                  <span name = "save_serie_and_send" className={'btn_param'+(save_serie_and_send ? ' active' :'')} onClick={()=>setSave_serie_and_send(true)}>Oui</span> &nbsp;
                  <span name = "save_serie_and_send" className={'btn_param'+(!save_serie_and_send ? ' active' :'')} onClick={()=>setSave_serie_and_send(false)}>Non</span>
                  <br/><br/>
                  
                  {(save_serie || save_serie_and_send) && <button name="listeChoix" className="btn standard" style={{backgroundColor: auth.color_devoir[devoir_cree.classe], color:auth.color_btn[devoir_cree.classe], border:'2px solid '+auth.color_btn[devoir_cree.classe]}} onClick={handleSubmit} >{save_serie_and_send ? 'Envoyer au groupe ' + auth.classe : 'Sauvegarder'}</button> }
                </div>
            }
          </div>
        </div>
      }

    </div>
  );
}